import { set, toggle } from '@/utils/vuex'

export default {
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  setCourseList: set('courseList'),
  setLastDayVideoCount (state, val) {
    state.lastDayVideoCount = val
  },
  setLastDayExamCount (state, val) {
    state.lastDayExamCount = val
  }
}
